const smallMobileWidthVer = '320px';
const mobileAndPhabletWidthVer = '480px';

export default {
  desktop: '@media (min-width: 1025px)',
  mobileAndTablet: '@media(min-width: 360px) and (max-width: 1024px)',
  smallMobile: `@media(max-width: ${smallMobileWidthVer})`,
  mediumMobile: `@media(max-width: 340px)`,
  smallMobileAndTablet: `@media(min-width: ${smallMobileWidthVer}) and (max-width: 1024px)`,
  mobileAndPhablet: `@media(max-width: ${mobileAndPhabletWidthVer})`,
  tablet: '@media (min-width: 768px)',

  smallMobileHorizontal: `@media screen and (orientation:landscape) and (max-height: ${smallMobileWidthVer})`,
  mobileAndPhabletHorizontal: `@media screen and (orientation:landscape) and (max-height: ${mobileAndPhabletWidthVer})`,
};
